import { styled } from "styled-components";

export const AddButtonContainer = styled.div`
background: #1876d1;
color: #ffffff;
padding: 10px;
border-radius: 7px;
cursor: pointer;
`